<template>
    <v-dialog
        v-bind="$attrs" v-on="$listeners"
        width="480px"
    >
        <v-card>
            <v-card-title class="text-break">
                {{ servico.titulo }}
            </v-card-title>
            <v-card-text >
                <TextoComLinks v-if="servico.descricao" :texto="servico.descricao" />
            </v-card-text>
            <ContatoDoIrmao :irmao="servico.irmao" />
        </v-card>
        <template
            v-for="(_, name) in $scopedSlots"
            #[name]="slotProps = {}"
        >
        <slot
            v-bind="slotProps"
            :name="name"
        />
        </template>
    </v-dialog>
</template>

<script setup lang="ts">
import { Servico } from 'common/types/Servico';
import { defineComponent } from 'vue';
import TextoComLinks from '@/components/TextoComLinks.vue';
import ContatoDoIrmao from '../irmao/ContatoDoIrmao.vue';

defineComponent({
    inheritAttrs: true,
})

defineProps<{ servico: Servico }>()
</script>